var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCdSerIcon05(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2938_1084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.9575 55.443L30.0792 62.0233C30.2945 62.7189 31.1557 62.9342 31.6692 62.4208C34.8657 59.2242 40.1657 53.8414 40.5301 50.8933C40.7024 49.6312 40.2419 47.9518 39.7268 46.4678C36.6296 49.6163 32.7722 52.6737 27.9575 55.443Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5322 26.2732C18.0498 25.7581 16.3687 25.2976 15.1067 25.4699C12.1586 25.8343 6.77574 31.1343 3.57918 34.3308C3.06574 34.8443 3.28105 35.7055 3.97668 35.9208L10.557 38.0408C13.3262 33.2278 16.3836 29.3704 19.5322 26.2732Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3402 58.0035C10.759 60.6303 5.41928 60.6486 5.35303 60.6486C5.35303 60.5807 5.36959 55.2426 7.99806 50.6614L15.3402 58.0035Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5381 27.1874C34.6636 27.1874 33.8421 27.5286 33.2243 28.1463C32.6049 28.7658 32.2637 29.5873 32.2637 30.4618C32.2637 31.3363 32.6049 32.1594 33.2243 32.7772C34.4582 34.0161 36.6163 34.0161 37.8535 32.7772C39.1305 31.5003 39.1305 29.4233 37.8535 28.1463C37.2341 27.5286 36.4109 27.1874 35.5381 27.1874Z",
    fill: "#0e131c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.604 16.2959C41.3765 16.4135 22.3693 18.878 10.5172 43.4253C10.1363 44.2136 10.3019 45.1627 10.9213 45.7805L20.2179 55.077C20.8373 55.6964 21.7847 55.862 22.573 55.4811C47.122 43.6306 49.5865 24.6235 49.7041 18.396C49.7256 17.2201 48.7799 16.2744 47.604 16.2959ZM39.962 34.8856C38.7795 36.0665 37.2093 36.7175 35.5382 36.7175C33.867 36.7175 32.2952 36.0665 31.1143 34.8856C29.9334 33.7047 29.2825 32.133 29.2825 30.4618C29.2825 28.7906 29.9351 27.2189 31.1143 26.038C33.4761 23.6761 37.5969 23.6761 39.962 26.038C42.4 28.4776 42.4 32.446 39.962 34.8856Z",
    fill: "#0e131c"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2938_1084"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdSerIcon05);
export default __webpack_public_path__ + "static/media/cd-ser_icon05.83d7d2649cf87a787d68323e66e44ee2.svg";
export { ForwardRef as ReactComponent };